import React, { useState } from 'react';
function FruitsZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >الحالة</th>
          <th > النتائج</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>نصاب زكاة الثمار والزروع</td>
          <td>{result.threshold} (كغ)</td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من الثمار)</td>
          <td>{result.fruitsZakatAmount} (كغ) </td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من المال)</td>
          <td>{result.moneyZakatAmount}</td>
        </tr>
      </tbody>
    </table>
  );
}
export default FruitsZakatTable;
